import type { UseUpdateOptions } from "./useUpdate.type";
import type { ApiError, ApiPayloadUpdate } from "@/services/api";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useUpdate = <Data = unknown, Variables = unknown>(
  model: string,
  id: number,
  options?: UseUpdateOptions<Data, Variables>
) => {
  const queryClient = useQueryClient();

  const { invalidateKeys, rootId, mutationOptions } = options ?? {};

  const mutationFn = (variables: Variables) => {
    return rootId
      ? client[model].update(rootId, id, variables)
      : client[model].update(id, variables);
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: [model] });
    invalidateKeys?.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );
  };

  return useMutation<ApiPayloadUpdate<Data>, ApiError, Variables>({
    ...mutationOptions,
    mutationFn,
    onSuccess,
  });
};
